import { takeLatest, select, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { ISearchQuery, HotelNameResponse } from 'services/BackendApi';
import qs from 'qs';
import * as Actions from '../actions';
import * as Selectors from '../selectors';

import * as AgentsSelectors from 'store/modules/agents/selectors';
import * as FastSearchActions from 'store/modules/fastSearch/actions';
import * as AgentsActions from 'store/modules/agents/actions';

import * as AuthSelectors from 'store/modules/auth/selectors';
import { ParameterService } from 'services/ParametersProviderApi/ParametersService';
import { getBookingBuilderPath } from 'utils/bookingBuilderPath';

export function* executeSaga(action: Actions.ExecuteAction) {
  try {
    const searchQuery: ISearchQuery = yield select(Selectors.offersQuerySelector);
    const selectedCompanyMembership = yield select(AgentsSelectors.selectedCompanyMembershipSelector);
    // OWA-10162: Set or remove membership based on current selection
    if (selectedCompanyMembership) {
      searchQuery.membership = selectedCompanyMembership.uuid;
    } else {
      delete searchQuery.membership;
    }
    yield put(FastSearchActions.populateQueryAction(searchQuery));

    const isSR = yield select(AuthSelectors.isInternalUser);
    let selectedCompany: any = null;
    let selectedTA: any = null;
    
    if (isSR) {
      selectedCompany = yield select(Selectors.selectedCompanySelector);
      yield put(AgentsActions.selectedCompanyChangeAction(selectedCompany));

      selectedTA = yield select(Selectors.selectedTaSelector);
      yield put(AgentsActions.selectedTaChangeAction(selectedTA));
    } else {
      // For non-SR users, get company/TA from agents selectors
      selectedCompany = yield select(AgentsSelectors.selectedCompanySelector);
      selectedTA = yield select(AgentsSelectors.selectedTaSelector);
    }

    const hotel: HotelNameResponse | null = yield select(Selectors.hotelSelector);

    // Read currency from current URL — CurrencyConversionProvider keeps this in sync with user's selection.
    // searchQuery must NOT be relied on for currency because it's stale (set from URL on mount, never updated).
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentCurrency = currentSearchParams.get('currency');

    // Add company and TA UUIDs to the query
    const queryWithCompanyTa = {
      ...searchQuery,
      ...(selectedCompany?.uuid && { companyUuid: selectedCompany.uuid }),
      ...(selectedTA?.uuid && { tauuid: selectedTA.uuid }),
      ...(hotel?.uuid && { hotelUuid: hotel.uuid }),
      ...(currentCurrency ? { currency: currentCurrency } : {}),
    };

    const page = hotel ? getBookingBuilderPath(ParameterService.getParameters()) : '/search/beta';
    yield put(push(`${page}?${qs.stringify(queryWithCompanyTa)}`));
  } catch (e) {
    console.log(e);
  }
}

export function* watchExecute() {
  yield takeLatest(Actions.EXECUTE, executeSaga);
}
